export const Dimensions = {
         DefaultCardPadding: 16,
         DefaultGridSpacing: 3,
         DefaultItemHeight: 32,
         DefaultEdgeAlign: 16,
         ThemeSpacingUnit: 8,
         BorderRadius: 4,
       };
